import React, { useCallback, useMemo, useState } from 'react';

export default function APIDocs() {
  const backend = process.env.REACT_APP_BACKEND_URL || 'http://localhost:7001';
  const docsUrl = useMemo(() => `${backend.replace(/\/$/, '')}/api-docs`, [backend]);
  const [key, setKey] = useState(0);

  const openInNewTab = useCallback(() => {
    window.open(docsUrl, '_blank', 'noopener');
  }, [docsUrl]);

  const refresh = useCallback(() => {
    // bump key to force iframe reload
    setKey((k) => k + 1);
  }, []);

  return (
    <div className="w-full h-full flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">API Documentation</h1>
          <p className="text-sm text-gray-600">Interactive Swagger UI loaded from the backend. Use the toolbar to open in a new tab or refresh.</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={refresh} className="btn btn-sm bg-slate-100 px-3 py-1 rounded">Refresh</button>
          <button onClick={openInNewTab} className="btn btn-sm bg-blue-600 text-white px-3 py-1 rounded">Open in new tab</button>
        </div>
      </div>

      <div className="flex-1 border rounded overflow-hidden">
        <iframe
          key={key}
          title="API Documentation"
          src={docsUrl}
          className="w-full h-full"
          style={{ minHeight: '72vh', border: '0' }}
        />
      </div>
    </div>
  );
}
